/**
 * Product-page collapsible_tab height animation — Lovable shadcn Accordion parity.
 *
 * Native <details>/<summary> can't transition height: auto via CSS alone, so we
 * intercept the summary click, manage the open attribute ourselves, and animate
 * the content height with the Web Animations API. After the animation finishes,
 * the inline height style is cleared so future content changes (e.g., dynamic
 * inserts) layout naturally as height: auto.
 *
 * Targets: all .product__accordion details on the product page. Applies the
 * same animation to ALL 3 dropdowns (description, shipping, ingredients) for
 * consistency — the prior instant-collapse behavior is replaced wholesale.
 *
 * Multi-open semantic preserved: <details> elements are independent; opening
 * one doesn't close others. Matches Lovable's <Accordion type="multiple">.
 *
 * Reduced-motion: skip animation entirely, just toggle the open attribute.
 * Chevron rotation transition is separately handled by component-accordion.css
 * + a reduced-motion @media override.
 */
(function () {
  'use strict';

  var REDUCE_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 200;
  var EASING = 'cubic-bezier(0, 0, 0.2, 1)'; // ease-out

  function cancelRunning(el) {
    if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); });
  }

  function expand(details, content) {
    cancelRunning(content);
    details.dataset.collapsibleAction = 'expanding';
    details.open = true;
    if (REDUCE_MOTION) { details.dataset.collapsibleAction = ''; return; }
    var endHeight = content.scrollHeight;
    var startHeight = content.getBoundingClientRect().height; // may be mid-collapse height; animate from there
    content.style.overflow = 'hidden';
    content.style.height = startHeight + 'px';
    void content.offsetHeight;
    var anim = content.animate(
      [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
      { duration: DURATION, easing: EASING, fill: 'forwards' }
    );
    anim.onfinish = function () {
      anim.cancel();
      content.style.height = '';
      content.style.overflow = '';
      details.dataset.collapsibleAction = '';
    };
  }

  function collapse(details, content) {
    cancelRunning(content);
    details.dataset.collapsibleAction = 'collapsing';
    if (REDUCE_MOTION) { details.open = false; details.dataset.collapsibleAction = ''; return; }
    var startHeight = content.getBoundingClientRect().height;
    content.style.overflow = 'hidden';
    content.style.height = startHeight + 'px';
    void content.offsetHeight;
    var anim = content.animate(
      [{ height: startHeight + 'px' }, { height: '0px' }],
      { duration: DURATION, easing: EASING, fill: 'forwards' }
    );
    anim.onfinish = function () {
      anim.cancel();
      details.open = false;
      content.style.height = '';
      content.style.overflow = '';
      details.dataset.collapsibleAction = '';
    };
  }

  // Click decision: use `data-collapsible-action` as the in-flight direction
  // (set immediately when expand/collapse starts, cleared when animation finishes).
  // Falls back to details.open for the steady state. This makes rapid toggles
  // (click-close → click-open while still animating) end up at the user's last-
  // requested direction; reading details.open alone lags behind the animation.
  function intendedAction(details) {
    var action = details.dataset.collapsibleAction;
    if (action === 'expanding') return 'collapse';
    if (action === 'collapsing') return 'expand';
    return details.open ? 'collapse' : 'expand';
  }

  function init() {
    var accordions = document.querySelectorAll('.product__accordion details');
    accordions.forEach(function (details) {
      if (details.dataset.collapsibleInit) return;
      details.dataset.collapsibleInit = '1';
      var summary = details.querySelector('summary');
      var content = details.querySelector('.accordion__content');
      if (!summary || !content) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (intendedAction(details) === 'collapse') collapse(details, content);
        else expand(details, content);
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
